import { internationalCurrencyFormat } from './currency';
import { PAYMENT_NETWORK_RECIPIENT_TYPES } from "./enums";
import moment from 'moment';

const transformationsByType = {
  removeCurrencyFormatting: val => val.replace(/[^0-9,.]/g, ""),
  formatAsCurrency: (val, config, data) => internationalCurrencyFormat(val, data),
  formatDate: (val, config = {}) => {
    try {
      const { format } = config;
      return moment(val).format(format || 'MMMM Do, YYYY')
    }
    catch (err) {
      console.log(err);
      return val;
    }
  },
  multiply: (value, config) => {
    try {
      const { multiplier } = config;
      return Number.parseFloat(value) * multiplier;
    }
    catch (err) {
      console.log(err);
      return value;
    }
  },
  ceil: value => Math.ceil(value),
  formatPaymentNetworkRecipientType: (val) => {
    switch (val) {
      case PAYMENT_NETWORK_RECIPIENT_TYPES.EMAIL:
        return 'emailed to ';
      case PAYMENT_NETWORK_RECIPIENT_TYPES.SMS:
        return 'sent via text to ';
      default:
        return val;
    }
  },
  formatPhoneNumber: (val) => {
    const cleaned = ('' + val).replace(/\D/g, '');
    const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      const intlCode = (match[1] ? '+1 ' : '');
      return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
    }

    return val;
  },
  formatEmailAddressOrMobilePhoneNumber: (val, config, data) => {
    function formatPhoneNumber(phoneNumber) {
      const cleaned = ('' + phoneNumber).replace(/\D/g, '');
      const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
      if (match) {
        const intlCode = (match[1] ? '+1 ' : '');
        return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
      }
      return phoneNumber;
    }

    switch (val) {
      case PAYMENT_NETWORK_RECIPIENT_TYPES.EMAIL:
        return data.payment.recipientEmail;
      case PAYMENT_NETWORK_RECIPIENT_TYPES.SMS:
        return formatPhoneNumber(data.payment.recipientMobilePhone);
      default:
        return val;
    }
  }
};

// sample transformations config
// "transformations": [
//   {
//     "type": "multiply",
//     "config": {
//       "multiplier": 1.25
//     }
//   }
// ]

export const applyTransformations = (initialValue, transformations = []) => {
  if (!transformations.length) return initialValue;
  return transformations.reduce((transformedValue, transformation) => {
    const transformer = transformationsByType[transformation.type];
    return transformer(transformedValue, transformation.config, transformation.data);
  }, initialValue);
};
